/* IMPORT */
import { OBSERVABLE_FALSE } from '../constants.js';
import { OWNER } from '../objects/superroot.js';
import { readable } from '../objects/callable.js';
import Observable from '../objects/observable.js';
import { SYMBOL_SUSPENSE } from '../symbols.js';
/* MAIN */
const suspended = (stack) => {
    const suspense = OWNER.get(SYMBOL_SUSPENSE);
    if (!suspense)
        return OBSERVABLE_FALSE;
    const observable = (suspense.observable || (suspense.observable = new Observable(!!suspense.suspended)));
    return readable(observable, stack);
};
/* EXPORT */
export default suspended;
